import { z } from 'zod';

/** Valeurs alignées sur la migration 0003 du référentiel EauÉnergie Connect. */
export const TYPES_ORGANISATION = [
  'ministere',
  'exploitant',
  'regulateur',
  'cnee',
  'prestataire',
  'support',
] as const;
export const DOMAINES_SERVICE = ['electricite', 'eau', 'mixte', 'aucun'] as const;
export type TypeOrganisation = (typeof TYPES_ORGANISATION)[number];
export type DomaineService = (typeof DOMAINES_SERVICE)[number];
export const schemaTypeOrganisation = z.enum(TYPES_ORGANISATION);
export const schemaDomaineService = z.enum(DOMAINES_SERVICE);

export const schemaCreationOrganisation = z
  .object({
    nom: z.string().trim().min(2).max(200),
    sigle: z.string().trim().min(1).max(40),
    code_court: z.string().regex(/^[A-Z0-9]{2,8}$/),
    type: schemaTypeOrganisation,
    domaine: schemaDomaineService,
    province_id: z.uuid().nullable(),
    departement_id: z.uuid().nullable().default(null),
  })
  .superRefine((valeur, contexte) => {
    if (valeur.type === 'exploitant' && !['eau', 'electricite'].includes(valeur.domaine)) {
      contexte.addIssue({
        code: 'custom',
        path: ['domaine'],
        message: 'Un exploitant doit être rattaché à l’eau ou à l’électricité',
      });
    }
    if (valeur.departement_id && !valeur.province_id) {
      contexte.addIssue({
        code: 'custom',
        path: ['province_id'],
        message: 'La province est requise avec un département',
      });
    }
  });
